<template>
    <div class="spin-wrap">
        <div class="spin">
            <span class="minus" @click="updateQuantity('-')">
                <i class="fas fa-minus" aria-hidden="true"></i>
            </span>
                <input name="quantity"
                       type="number"
                       class="js-quantity"
                       value="1"
                       min="1"
                       step="1"
                       v-model="quantity"
                       @change="setQuantity"
                >
                <span class="plus" @click="updateQuantity('+')">
                <i class="fas fa-plus" aria-hidden="true"></i>
            </span>
        </div>
        <span>{{ mu }}</span>
    </div>
</template>

<script>
    export default {
        props: {
            muProp: {
                required: true,
                type: String,
            }
        },

        data() {
            return {
                quantity: 1,
                mu: this.muProp
            }
        },

        created() {
            if ( this.mu.length < 1 ) this.mu = 'Ks';
        },

        methods: {
            setQuantity() {
                this.$root.$emit('updateQuantity', this.quantity);
            },

            updateQuantity(action) {
                if ( action === '+' ) this.quantity++;
                else this.quantity--;

                if ( this.quantity < 1 ) this.quantity = 1;

                this.setQuantity();
            }
        }
    }
</script>
